import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useCompleteDataTransCC } from 'featureSliced/shared/hooks/useCompleteDataTransCC'

export const CCConfirmation = () => {
  // Hooks
  const [searchParams] = useSearchParams()
  const completeDataTrans = useCompleteDataTransCC()
  const isAppInit = useMySelector((state) => state.app.isAppInit)

  const show_payment_variant = searchParams.get('show_payment_variant')
  const datatransTrxId = searchParams.get('datatransTrxId')
  const order_guid = searchParams.get('orderGuid')
  const show_card = searchParams.get('show_card')

  // useEffect
  useEffect(() => {
    if (
      datatransTrxId &&
      (order_guid || show_card || show_payment_variant) &&
      isAppInit
    ) {
      completeDataTrans()
    }
  }, [isAppInit, searchParams])

  return null
}
